import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import MainLayout from 'src/layouts/main';
import CompactLayout from 'src/layouts/compact';
// components
import { SplashScreen } from 'src/components/loading-screen';
import ShopFloorDisplayLinkView from 'src/sections/main-sections/build-mode/view/shop-floor-display-link-view';
// ----------------------------------------------------------------------

export const HomePage = lazy(() => import('src/pages/home'));
const Page500 = lazy(() => import('src/pages/500'));
const Page403 = lazy(() => import('src/pages/403'));
const Page404 = lazy(() => import('src/pages/404'));
const FaqsPage = lazy(() => import('src/pages/faqs'));
const AboutPage = lazy(() => import('src/pages/about-us'));
const ContactPage = lazy(() => import('src/pages/contact-us'));
const ComingSoonPage = lazy(() => import('src/pages/coming-soon'));
const MaintenancePage = lazy(() => import('src/pages/maintenance'));

const TacPage = lazy(() => import('src/pages/terms-and-conditions'));
const PrivacyPolicyPage = lazy(() => import('src/pages/privacy-policy'));
const QuoteResponsePage = lazy(() => import('src/pages/main-dashboard/quote/quote-action-page')); 
const QuotePaymentPage = lazy(() => import('src/pages/main-dashboard/quote/quote-payment-page'));
const PayInvoicePage = lazy(() => import('src/pages/main-dashboard/invoices/pay-invoice-page'));

// ----------------------------------------------------------------------

export const mainRoutes = [
  {
    element: (
      <MainLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </MainLayout>
    ),
    children: [
      { path: 'about-us', element: <AboutPage /> },
      { path: 'contact-us', element: <ContactPage /> },
      { path: 'faqs', element: <FaqsPage /> },
      { path: 'terms-and-conditions', element: <TacPage /> },
      { path: 'privacy-policy', element: <PrivacyPolicyPage /> },
    ],
  },
  {
    element: (
      <CompactLayout>
        <Suspense fallback={<SplashScreen />}>
          <Outlet />
        </Suspense>
      </CompactLayout>
    ),
    children: [
      { path: 'coming-soon', element: <ComingSoonPage /> },
      { path: 'maintenance', element: <MaintenancePage /> },
      { path: '500', element: <Page500 /> },
      { path: '404', element: <Page404 /> },
      { path: '403', element: <Page403 /> },
    ],
  },
  { path: 'quote/respond', element : <QuoteResponsePage />},
  { path: 'quote/payment', element : <QuotePaymentPage />},
  { path: 'invoice/pay', element: <PayInvoicePage /> },
  { path: 'build-mode/shop-floor-display', element : <ShopFloorDisplayLinkView />},
];
